
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ContentItem } from "@/types/content-library";
import { Link } from "react-router-dom";

interface ContentCardProps {
  content: ContentItem;
}

const categoryColorMap: Record<string, string> = {
  marketing: "bg-blue-100 text-blue-800",
  integration: "bg-purple-100 text-purple-800",
  cashback: "bg-green-100 text-green-800",
  referral: "bg-yellow-100 text-yellow-800",
  campaign: "bg-orange-100 text-orange-800",
  analytics: "bg-indigo-100 text-indigo-800",
  setup: "bg-gray-100 text-gray-800",
};

const ContentCard = ({ content }: ContentCardProps) => {
  const cardType = content.type === 'video' ? 'Vídeo' : 'Artigo';
  
  return (
    <Link to={`/content-library/${content.id}`} className="block group h-full">
      <Card className="h-full transition-all duration-200 hover:shadow-lg hover:-translate-y-1 flex flex-col">
        <div 
          className="h-24 sm:h-32 bg-gray-100 rounded-t-lg overflow-hidden relative"
          style={{ backgroundImage: `url(${content.thumbnail})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
        >
          <div className="absolute top-2 right-2">
            <Badge variant="outline" className="bg-white text-xs">
              {cardType}
            </Badge>
          </div>
        </div>
        <CardHeader className="pb-2 pt-3 sm:pt-4 px-3 sm:px-6 flex-grow">
          <div className="flex justify-between items-start mb-2">
            <Badge className={`${categoryColorMap[content.category] || "bg-gray-100"} text-xs`}>
              {content.category.charAt(0).toUpperCase() + content.category.slice(1)}
            </Badge>
          </div>
          <CardTitle className="text-sm sm:text-base group-hover:text-primary transition-colors line-clamp-2 leading-tight">
            {content.title}
          </CardTitle>
        </CardHeader>
        <CardContent className="pb-2 pt-0 px-3 sm:px-6">
          <CardDescription className="line-clamp-2 text-xs sm:text-sm leading-relaxed">
            {content.description}
          </CardDescription>
        </CardContent>
        <CardFooter className="text-xs text-gray-500 pt-0 px-3 sm:px-6 pb-3 sm:pb-4">
          {new Date(content.updatedAt).toLocaleDateString('pt-BR')}
        </CardFooter>
      </Card>
    </Link>
  );
};

export default ContentCard;
